export default "__VITE_ASSET__CUEjR_Mw__"